module.exports = __webpack_public_path__ + "static/media/cs.6b87a04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/HomePage/cs.png
// module id = 864
// module chunks = 0